import React from 'react';
import { Badge } from './Badge';
import { cn } from './cn';

/**
 * PageHeader — title block at the top of a page.
 *
 *   <PageHeader
 *     title="Clients"
 *     count={128}
 *     description="All active tenants on the platform."
 *     actions={<Button>New client</Button>}
 *   />
 */
export function PageHeader({ title, description, count, actions, meta, className }) {
  return (
    <div className={cn('flex items-start justify-between gap-4 mb-5', className)}>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h1 className="text-h1 text-fg truncate">{title}</h1>
          {count != null && (
            <Badge variant="neutral" size="sm">
              {count}
            </Badge>
          )}
        </div>
        {description && (
          <p className="mt-1 text-body-sm text-fg-muted max-w-2xl">{description}</p>
        )}
        {meta && <div className="mt-2 flex items-center gap-3 text-caption text-fg-subtle">{meta}</div>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export default PageHeader;
